var FilePresetModel = function (pageModelHndl) {
    var that = this;

    that.FilePresetUrl = ko.observable("#");
    that.IsFilePresetAvailable = ko.observable(false);

    that.GetFilePreset = function () {
        var productConfigurationFilterModel = new ProductConfigurationFilterModel(pageModelHndl);
        productConfigurationFilterModel.IsCatalogueProduct = pageModelHndl.IsCatalogueProduct();
        var data = ko.mapping.toJSON(productConfigurationFilterModel);
        console.log("getFilePreset sending ", JSON.parse(data));

        var url = $("#ResolveFilePresetUrl").val();

        return $.ajax({
            url: url,
            type: "POST",
            data: data,
            dataType: "json",
            contentType: "application/json; charset=utf-8",
        }).done(function(data) {
            if (!data.Success) {
                alerts.error();
                return;
            }
            that.FilePresetUrl(data.Model.url);
            that.IsFilePresetAvailable(data.Model.isFilePresetAvailable);
        }).fail(function() {
            alerts.error();
        }).always(function() {

        });
    };
};